/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import {
    IMultiAxisDatasetNode,
    IMultiAxisDatasetVisitNode,
    IMultiAxisDatasetVisitor
} from '../types/MultiAxisDatasetTypes';

function visitMultiAxisDatasetNodeInternal<T>(
    node: IMultiAxisDatasetNode,
    preVisit: IMultiAxisDatasetVisitNode<T> | undefined,
    postVisit: IMultiAxisDatasetVisitNode<T> | undefined,
    incomingProps: T,
    currentDepth = 0,
    currentIndex = 0,
    visitAll: boolean
): T {
    let processedContext = incomingProps;

    if (preVisit) {
        processedContext = preVisit(node, processedContext, currentDepth, currentIndex);
    }

    if (visitAll || node.expanded || (node.children.length && node.children[0].isMeasure)) {
        node.children.forEach((child, index) => {
            processedContext = visitMultiAxisDatasetNodeInternal(child, preVisit, postVisit, processedContext, currentDepth + 1, index, visitAll);
        });
    }

    if (node.total) {
        processedContext = visitMultiAxisDatasetNodeInternal(node.total, preVisit, postVisit, processedContext, currentDepth + 1, 0, visitAll);
    }

    if (postVisit) {
        processedContext = postVisit(node, processedContext, currentDepth, currentIndex);
    }

    return processedContext;
}

export default function visitMultiAxisDatasetNode<T>(
    node: IMultiAxisDatasetNode,
    visitor: IMultiAxisDatasetVisitor<T>,
    incomingProps: T,
    visitAll: boolean = false
): T {
    let processedContext: T = incomingProps;

    if (visitor.preVisit) {
        processedContext = visitor.preVisit(processedContext);
    }

    processedContext = visitMultiAxisDatasetNodeInternal(node, visitor.preVisitNode, visitor.postVisitNode, processedContext, 0, 0, visitAll);

    if (visitor.postVisit) {
        processedContext = visitor.postVisit(processedContext);
    }

    return processedContext;
}
